import "./styles.css";
import { Home } from "./pages/Home";
import { mount } from "./hydrate";

mount(<Home />);
